import { render, staticRenderFns } from "./delivery-revoke-records.vue?vue&type=template&id=56ce3c11&scoped=true"
import script from "./delivery-revoke-records.vue?vue&type=script&lang=js"
export * from "./delivery-revoke-records.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce3c11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ce3c11')) {
      api.createRecord('56ce3c11', component.options)
    } else {
      api.reload('56ce3c11', component.options)
    }
    module.hot.accept("./delivery-revoke-records.vue?vue&type=template&id=56ce3c11&scoped=true", function () {
      api.rerender('56ce3c11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/preSale-management/delivery-revoke-records/delivery-revoke-records.vue"
export default component.exports